import ShareAndGalleryForm from './ShareAndGalleryForm';

export default function CreateEventStepThree({
    onNext,
    foregroundColor,
    backgroundColor,
    headerForegroundColor,
    headerBackgroundColor,
    shareViaText,
    shareViaEmail,
    galleryLogo,
    setGalleryLogo,
    setShareViaText,
    setShareViaEmail,
    setCustomMessage,
    customMessage,
    setForegroundColor,
    setBackgroundColor,
    setHeaderForegroundColor,
    setHeaderBackgroundColor,
}: {
    onNext: () => void;
    foregroundColor: string;
    setForegroundColor: (color: string) => void;
    backgroundColor: string;
    setBackgroundColor: (color: string) => void;
    headerForegroundColor: string;
    setHeaderForegroundColor: (color: string) => void;
    headerBackgroundColor: string;
    setHeaderBackgroundColor: (color: string) => void;
    customMessage: string;
    setCustomMessage: (message: string) => void;
    shareViaText: boolean;
    setShareViaText: (enabled: boolean) => void;
    shareViaEmail: boolean;
    setShareViaEmail: (enabled: boolean) => void;
    galleryLogo: string | null;
    setGalleryLogo: (image: string | null) => void;
}) {
    return (
        <ShareAndGalleryForm
            onNext={onNext}
            foregroundColor={foregroundColor}
            backgroundColor={backgroundColor}
            headerForegroundColor={headerForegroundColor}
            headerBackgroundColor={headerBackgroundColor}
            shareViaText={shareViaText}
            shareViaEmail={shareViaEmail}
            galleryLogo={galleryLogo}
            setGalleryLogo={setGalleryLogo}
            setForegroundColor={setForegroundColor}
            setBackgroundColor={setBackgroundColor}
            setHeaderForegroundColor={setHeaderForegroundColor}
            setHeaderBackgroundColor={setHeaderBackgroundColor}
            setShareViaText={setShareViaText}
            setShareViaEmail={setShareViaEmail}
            setCustomMessage={setCustomMessage}
            customMessage={customMessage}
            showNextButton={true}
        />
    );
}
